import clsx from 'clsx';
import React from 'react';
import { useDispatch } from 'react-redux';
import Button from '../../components/Button';
import ToggleIcon from '../../assets/icons/sidebar-toggle-icon.svg?react';
import { toggleSwitch } from '../../reducers/switch';
import Input from '../../components/Input';
import TextArea from '../../components/TextArea';

interface CreateOshaReportStepThreeProps {
  otherClasses?: string;
  handleSteps: (steps: number) => void;
  isResubmit?: boolean;
  formHandler: any;
  disbaleButtons?: boolean;
}

const CreateOshaReportStepThree: React.FC<CreateOshaReportStepThreeProps> = ({
  otherClasses,
  handleSteps,
  formHandler,
  isResubmit,
  disbaleButtons,
}) => {
  const createOshaReportStepThreeClasses = clsx(otherClasses);
  const dispatch = useDispatch();

  return (
    <div
      className={createOshaReportStepThreeClasses}
      data-testid="create-osha-report-step-three"
    >
      <div className="flex lg:gap-10 xl:items-center xl:justify-between">
        <div className="flex flex-1 items-start gap-2.5">
          <button
            type="button"
            className="bg-translucent-background/80 border-neutral-tones-text/30 rounded-5 cursor-pointer border p-0.5 lg:hidden"
            onClick={() => dispatch(toggleSwitch())}
          >
            <ToggleIcon />
          </button>
          <div>
            <h1 className="h3 mb-1 lg:mb-0">OSHA 300A</h1>
            <p className="text-brand-byzantine font-inter-variable -tracking-button text-base leading-5 font-bold lg:text-xl lg:leading-6">
              STEP 3 / 3
            </p>
          </div>
        </div>
      </div>
      <p className="font-inter-variable text-neutral-tones-text/80 -tracking-button mt-8 text-sm leading-4 font-medium lg:mt-15 lg:text-xl lg:leading-6">
        Input the details of your establishment to complete your submission.
      </p>
      <p className="font-inter-variable text-neutral-tones-text/80 -tracking-button mt-8 text-sm leading-4 font-medium lg:mt-15 lg:text-xl lg:leading-6">
        Ensure accuracy when submitting to OSHA - incorrect or fraudulent data
        may incur penalties.
      </p>

      <div className="mt-9 w-full">
        <h4 className="text-brand-byzantine font-semibold">
          Employment Information
        </h4>
        <div className="mt-9 flex w-full max-w-3xl flex-col items-start gap-25">
          <Input
            onBlur={formHandler?.handleBlur}
            label={
              <>
                Annual average number of employees
                <span className="text-brand-posh-pink">*</span>
              </>
            }
            errorMessage={
              formHandler?.touched.annualAverageNumberOfEmployees &&
              formHandler?.errors.annualAverageNumberOfEmployees
                ? formHandler?.errors.annualAverageNumberOfEmployees
                : ''
            }
            disabled={formHandler?.isSubmitting}
            value={formHandler?.values.annualAverageNumberOfEmployees}
            type="number"
            placeholder="Enter annual average number of employees"
            onChange={formHandler?.handleChange}
            name="annualAverageNumberOfEmployees"
            otherClasses={{
              container: 'w-full lg:gap-25',
              label: 'text-sm sm:text-lg lg:text-xl font-bold',
            }}
          />
          <Input
            onBlur={formHandler?.handleBlur}
            label={
              <>
                Total hours worked by all employees last year
                <span className="text-brand-posh-pink">*</span>
              </>
            }
            errorMessage={
              formHandler?.touched.annualAverageNumberOfEmployeesWorkingHours &&
              formHandler?.errors.annualAverageNumberOfEmployeesWorkingHours
                ? formHandler?.errors.annualAverageNumberOfEmployeesWorkingHours
                : ''
            }
            disabled={formHandler?.isSubmitting}
            value={
              formHandler?.values.annualAverageNumberOfEmployeesWorkingHours
            }
            type="number"
            placeholder="Enter total hours worked by all employees last year"
            onChange={formHandler?.handleChange}
            name="annualAverageNumberOfEmployeesWorkingHours"
            otherClasses={{
              container:
                'w-full  lg:gap-25 [&>span]:bottom-auto [&>span]:top-24 sm:[&>span]:top-[102px] lg:[&>span]:top-[118px]',
              input: 'w-full',
              label: 'text-sm sm:text-lg lg:text-xl font-bold',
            }}
          />
          {isResubmit && (
            <TextArea
              onBlur={formHandler?.handleBlur}
              label={
                <>
                  Reason For Resubmission
                  <span className="text-brand-posh-pink">*</span>
                </>
              }
              errorMessage={
                formHandler?.touched.reason && formHandler?.errors.reason
                  ? formHandler?.errors.reason
                  : ''
              }
              disabled={formHandler?.isSubmitting}
              value={formHandler?.values.reason}
              placeholder="Enter reason"
              onChange={formHandler?.handleChange}
              name="reason"
              otherClasses={{
                container: 'w-full lg:gap-25',
                input: 'w-full',
                label: 'text-sm sm:text-lg lg:text-xl font-bold',
              }}
            />
          )}
        </div>
      </div>
      <div className="mt-12 flex items-center justify-center gap-15 sm:justify-start">
        <Button
          size="smaller"
          variant="secondary"
          type="button"
          onClick={() => handleSteps(2)}
          otherClasses="w-2/4 sm:w-174 text-brand-posh-pink  !border-brand-posh-pink hover:text-white  hover:!bg-brand-posh-pink"
        >
          Previous
        </Button>
        <Button
          type="submit"
          size="smaller"
          otherClasses="w-2/4 sm:w-174"
          disable={formHandler?.isSubmitting || disbaleButtons}
        >
          Proceed
        </Button>
      </div>
    </div>
  );
};

export default CreateOshaReportStepThree;
